import { useMutation, useQueryClient } from 'react-query';
import { useModal } from 'store/modals';
import { updateUserRoleAPI } from './api';

export function useUpdateUserRole() {
  const { openModal } = useModal();
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError } = useMutation(
    (user) => updateUserRoleAPI(user),
    {
      onError: (error, user) => openModal({
        modalType: 'PopupModal',
        modalProps: {
          title: 'Unable to update user role',
          description: 'An error occurred while updating the user role.',
          onRetry: () => mutate(user),
        },
      }),
      onSuccess: () => {
        queryClient.invalidateQueries('users');
      },
    },
  );

  return {
    updateUserRole: mutate,
    isLoading,
    isError,
  };
}
